import { GRAPH_URL } from "../../../constants";
import { getAuthorizationHeader } from "./authorization";

const query = `
  mutation CreateTopNineOrder($stripe: StripeInput!) {
    createTopNineOrder(stripe: $stripe) {
      id
      status
      cost
    }
  }
`;

const submitTopnine = variables =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
      ...getAuthorizationHeader()
    },
    body: JSON.stringify({ query, variables })
  })
    .then(res => res.json())
    .then(res => {
      if (res.errors) {
        const message = res.errors[0].message;
        const error = new Error(message);
        error.name = res.errors[0].name;
        throw error;
      }
      return res;
    });

export default submitTopnine;
